import { FeatureFlag } from '../FeatureFlag';

export const useAlphaEyeHoldersTab = new FeatureFlag({
    key: 'use-alpha-eye-holders-tab',
    defaultValue: false,
});
